<template>
  <blockquote class="border-l-2 pl-6 italic [&:not(:first-child)]:mt-6">
    <slot />
  </blockquote>
</template>
